export default function hideDataPermissionCheck({
  permissionName,
  action = "VIEW",
  data,
}) {
  if (!permissionName) return data;

  let user = window.loggedInUser;

  if (!user) return "Autorisation refusée";

  if (user.isSuperAdmin) return data;

  if (!user.role) return "Autorisation refusée";

  if (!user.role[permissionName]) return "Autorisation refusée";

  if (!user.role[permissionName].includes(action))
    return "Autorisation refusée";

  return data;
}
